import { SortingState } from '@tanstack/react-table';
import { ExpectedQueryData } from 'components/table/hooks/useServerFilteredTable';
import { getSortParam } from 'components/table/utils/sorting';
import API from 'services/API';
import {
  AirbnbAnalyticsPropertyReview,
  AirbnbAnalyticsPropertyReviewsResponse,
} from './types/HostQuality.types';

export const PROPERTIES_REVIEWS_BASE_QUERY_KEY = 'propertyReviews';

export const propertyReviewsQuery = ({
  propertyUid,
  ownerUid,
  location,
  pageIndex,
  sorting,
  pageSize,
}: {
  propertyUid?: string;
  ownerUid?: string;
  location?: string;
  pageIndex: number;
  pageSize: number;
  sorting: SortingState;
}) => ({
  queryKey: [
    PROPERTIES_REVIEWS_BASE_QUERY_KEY,
    { pageIndex, sorting, pageSize, propertyUid, ownerUid, location },
  ],
  queryFn: async (): Promise<
    ExpectedQueryData<AirbnbAnalyticsPropertyReview>
  > => {
    const sort = getSortParam(sorting, {
      propertyName: 'PROPERTY',
      qualityStatus: 'QUALITY_STATUS',
      overallScore: 'OVERALL_SCORE',
      fiveStarReviews: 'FIVE_STAR_REVIEWS',
      cleanliness: 'CLEANLINESS',
      accuracy: 'ACCURACY',
      checkin: 'CHECKIN',
      communication: 'COMMUNICATION',
      location: 'LOCATION',
      value: 'VALUE',
      recentTripIssues: 'RECENT_TRIP_ISSUES',
    });

    const response = await API.post<AirbnbAnalyticsPropertyReviewsResponse>(
      `/api/internal/airbnb/analytics/property-reviews`,
      {
        _limit: pageSize,
        propertyUids: propertyUid ? [propertyUid] : [],
        ownerUids: ownerUid ? [ownerUid] : [],
        locations: location ? [location] : [],
        sortField: sort ? sort.sort : 'PROPERTY',
        sortDirection: sort ? sort.direction : 'ASC',
        page: pageIndex,
        pageSize,
      },
    );

    const { items, total } = response.data;

    return {
      _metadata: {
        totalCount: total,
        count: total,
      },
      data: items,
    };
  },
  enabled: true,
});
